import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/pages/Index/Index'
import Login from '@/pages/Login/Login'
import AdminLogin from '@/pages/Login/AdminLogin'
import Register from '@/pages/Register/Register'
import RegisterInfo from '@/pages/RegisterInfo/RegisterInfo'
import ResetPassword from '@/pages/ResetPassword/ResetPassword'
import ResourcePackage from '@/pages/ResourcePackage/ResourcePackage'
import ResourcePackage4Pic from '@/pages/ResourcePackage/ResourcePackage4Pic'

import Pay from '@/pages/Pay/Pay'
import PayConfirm from '@/pages/PayConfirm/PayConfirm'
import OrderConfirm from '@/pages/OrderConfirm/OrderConfirm'

import CustomerCenter from '@/pages/CustomerCenter/CustomerCenter'
import CustomerInfo from '@/pages/CustomerCenter/CustomerInfo/CustomerInfo'
import AccountSecurity from '@/pages/CustomerCenter/AccountSecurity/AccountSecurity'
import ApiKey from '@/pages/CustomerCenter/ApiKey/ApiKey'
// import Device from '@/pages/CustomerCenter/Device/Device'
import Product from '@/pages/CustomerCenter/Product/Product'
import PurchasedResourcePackage from '@/pages/CustomerCenter/PurchasedResourcePackage/PurchasedResourcePackage'
import PurchasedResourcePackage2 from '@/pages/CustomerCenter/PurchasedResourcePackage/PurchasedResourcePackage_c'
import Statistics from '@/pages/CustomerCenter/Statistics/Statistics'

import UpdatePassword from '@/pages/CustomerCenter/UpdatePassword/UpdatePassword'

import AdminCenter from '@/pages/AdminCenter/AdminCenter'
import AllCustomers from '@/pages/AdminCenter/AllCustomers/AllCustomers'
import AllOrders from '@/pages/AdminCenter/AllOrders/AllOrders'
import AllProduct from '@/pages/AdminCenter/AllProduct/AllProduct'
import AllPurchasedResourcePackage from '@/pages/AdminCenter/AllPurchasedResourcePackage/AllPurchasedResourcePackage'
import AllInvoices from '@/pages/AdminCenter/AllInvoices/AllInvoices'
import ReCache from '@/pages/AdminCenter/ReCache/ReCache'

Vue.use(VueRouter)

export default new VueRouter({
  mode:'history',
  routes: [  //要非常小心，是routes，不是routers，否则页面不会渲染
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      component: Index
    },
    {
      path: '/respkg',
      component: ResourcePackage
    },
    {
      path: '/vlrespkg',
      component: ResourcePackage4Pic
    },
    {
      path: '/customerCenter',
      component: CustomerCenter,
      children: [
        {
          path: '',
          redirect: '/customerCenter/customerInfo'
        },
        {
          path: '/customerCenter/customerInfo',
          component: CustomerInfo
        },
        {
          path: '/customerCenter/accountSecurity',
          component: AccountSecurity
        },
        {
          path: '/customerCenter/apiKey',
          component: ApiKey
        },
        // {
        //   path: '/customerCenter/device',
        //   component: Device
        // },
        {
          path: '/customerCenter/product',
          component: Product
        },
        {
          path: '/customerCenter/purchasedResPkg',
          component: PurchasedResourcePackage
        },
        {
          path: '/customerCenter/purchasedResPkg2',
          component: PurchasedResourcePackage2
        },
        {
          path: '/customerCenter/statistics',
          component: Statistics
        },
        {
          path: '/customerCenter/updatePassword',
          component: UpdatePassword
        }
      ]
    },
    {
      path: '/pay',
      component: Pay
    },
    {
      path: '/payConfirm',
      component: PayConfirm
    },
    {
      path: '/orderConfirm',
      component: OrderConfirm
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/register',
      component: Register
    },
    {
      path: '/registerInfo',
      component: RegisterInfo,
      beforeEnter: (to, from, next) => {
        const loginPhone = sessionStorage.getItem('loginPhone')
        if (!loginPhone) {
          next('/register')
        } else {
          // console.log('router beforeEnter', loginPhone)
          next()
        }
      }
    },
    {
      path: '/resetPassword',
      component: ResetPassword
    },
    {
      path: '/admLogin',
      component: AdminLogin
    },
    {
      path: '/adminCenter',
      component: AdminCenter,
      children: [
        {
          path: '',
          redirect: '/adminCenter/allCustomers'
        },
        {
          path: '/adminCenter/allCustomers',
          component: AllCustomers
        },
        {
          path: '/adminCenter/allOrders',
          component: AllOrders
        },
        {
          path: '/adminCenter/allProduct',
          component: AllProduct
        },
        {
          path: '/adminCenter/allPurchasedResourcePackage',
          component: AllPurchasedResourcePackage
        },
        {
          path: '/adminCenter/allInvoices',
          component: AllInvoices
        },
        {
          path: '/adminCenter/reCache',
          component: ReCache
        },
      ]
    },
    {
      path: '*',
      component: Index
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js